<div *ngIf="loading" class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog">
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
                 role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="data.mode==='new_folder' || data.mode==='new_file'">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;" *ngIf="data.mode==='new_folder'" >New Folder</h3>
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;"*ngIf="data.mode==='new_file'" >New File</h3>
    </div>

    <div class="dds__modal-body">
         <P>Folder: <i style="color: #0076ce;">{{data.parentFolder}}</i></P>
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080" *ngIf="data.mode==='new_folder'">New folder name</label>
             <label for="disabledTextInput" style="color:#808080" *ngIf="data.mode==='new_file'">New file name</label>
              <input type="text" [(ngModel)]="data.folder"
              id="disabledTextInput" class="dds__form-control" >
          </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-primary" [disabled]="!data.folder" [mat-dialog-close]="data.folder" cdkFocusInitial>Submit</button>
    </div>
  </div>

</div>


<!-- for edit -->
<div *ngIf="data.mode==='edit'">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Edit</h3>
    </div>

    <div class="dds__modal-body">
          <div class="dds__form-group">
             <label for="disabledTextInput" style="color:#808080">New Name</label>
              <input type="text" [(ngModel)]="data.folder"
              id="disabledTextInput" class="dds__form-control" >
          </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-primary" [mat-dialog-close]="data.folder" cdkFocusInitial>Submit</button>
    </div>
  </div>
</div>


<!-- for delete -->
<div *ngIf="data.mode==='delete'">
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Delete</h3>
    </div>

    <div class="dds__modal-body">
      <div id="nonEmptyFolderorFile">
         <p *ngIf="data.navItemType==='Folder' && data.isEmptyFolder">Are you sure you want to permanently delete <i style="color: #0076ce;">{{data.folder}}</i> from DLO KB?</p>
         <p *ngIf="data.navItemType==='File' && data.isEmptyFile">Are you sure you want to permanently delete <i style="color: #0076ce;">{{data.folder}}</i> from DLO KB?</p>
         <p *ngIf="data.navItemType==='Folder' && !data.isEmptyFolder">Are you sure you want to delete <i style="color: #0076ce;">{{data.folder}}</i> from DLO KB?</p>
         <p *ngIf=" data.navItemType==='File' && !data.isEmptyFile">Are you sure you want to delete <i style="color: #0076ce;">{{data.folder}}</i> from DLO KB?</p>
         <div *ngIf="data.navItemType==='Folder' && !data.isEmptyFolder">
          <input type="checkbox" required [(ngModel)]="clicked" (click)="toggle($event)">  I understand existing articles will also be removed.
        </div>
        <div *ngIf="data.navItemType==='Folder' && data.isEmptyFolder">
          <input type="checkbox" required [(ngModel)]="clicked" (click)="toggle($event)">  I understand this folder contains blank articles that cannot be restored.
        </div>
        <div *ngIf="data.navItemType==='File' && data.isEmptyFile">
          <input type="checkbox" required [(ngModel)]="clicked" (click)="toggle($event)">   I understand a blank article cannot be restored.
        </div>
      </div>
          </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-primary" [disabled]=" (data.navItemType==='Folder' || data.isEmptyFile)  && !clicked" [mat-dialog-close]="data.folder">Delete</button>
    </div>
  </div>
</div>
<!-- for restoring file-->
<div *ngIf="data.mode==='restore'" >
  <div class="dds__modal-content">
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Restore</h3>
    </div>

    <div class="dds__modal-body">
      <div class="dds__form-group">
        <div *ngIf="data.item.type=='File'"> <label for="disabledTextInput"  style="color:#808080">File Name<sup style="color: red;">*</sup></label></div>
        <div *ngIf="data.item.type=='Folder'"><label for="disabledTextInput"  style="color:#808080">Folder Name<sup style="color: red;">*</sup></label></div>     
        <input type="text" [(ngModel)]="data.folder"
               id="disabledTextInput" class="dds__form-control">
      </div>
      <div class="dds__form-group errortext">
        <label for="disabledTextInput" style="color: red;">{{data.duplictatefileNameMessage}}</label>
       
      </div>
    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
      <button class="dds__btn dds__btn-primary" [mat-dialog-close]="data.folder" cdkFocusInitial>Restore</button>
    </div>
  </div>
</div>
<!-- for restoring folder-->
 <div *ngIf="data.mode==='restore' && data.item.type=='Folder'" class="dds__modal-body" style="display: none;">
  <!-- <div *ngIf="data.mode==='restore' && data.item.type=='Folder'" class="dds__modal-body" style="display:none;"> -->
  <div class="dds__modal-content">
    <div   class="dds__modal-header" id="fileError" style="color: red;">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: red;"></h3>
    </div>
    <div  *ngIf="isInvalidRequest" class="dds__modal-header" >
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: red;">{{fileNameErrorMessage}}</h3>
    </div>
    <div  *ngIf="isNoFilesCheked" class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: red;">{{noFilesChekedError}}</h3>
    </div>
    <div class="dds__modal-header">
      <h3 class="dds__modal-title" id="dds__modal-title1" style="color: #0076ce;">Restore Folder</h3>
    </div>
    
     
   Folder Name: <input type="text" [(ngModel)]="data.item.displayName"
      id="disabledTextInput" class="dds__form-control">
   
    <div style="margin-top:10px;">
      <div *ngIf="data.item.children && data.item.children.length">
        <div class="dds__form-check dds__form-check-inline" *ngIf="data.activeFilesCount">
         <input type="checkbox" [(ngModel)]="isSelectAllChecked" style="height: auto;" class="dds__form-check-input" (change)="SelectAllFileOptions(data.item.children, $event)"> <label for="data.item.children" class="dds__form-check-label" style="color: #0076ce;">Select All</label>
      </div>
       
      
    
       
        <div  *ngFor="let children of data.item.children">
          <div  *ngIf="children.articleID">
          <div class="dds__form-check dds__form-check-inline">
          <input type="checkbox" [checked]="onlyoneFileChecked" 
            (change)="updateCheckedFileOptions(children, $event,data.item)" class="dds__form-check-input" style="height: auto;" />  <label for="fileName"  class="dds__form-check-label" style="color: #0076ce;">File Name:</label>
          </div>
            <input type="text" [(ngModel)]="children.displayName"
                   id="disabledTextInput" class="dds__form-control">
                  </div>
        </div>

      </div>

    </div>
    <div class="dds__modal-footer">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
     
      <button class="dds__btn dds__btn-primary" (click)="RestoreFolder(data.item)" cdkFocusInitial>Restore</button>
    </div> 
    <!-- <div class="dds__modal-footer"  *ngIf="data.activeFilesCount">
      <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
     
      <button class="dds__btn dds__btn-primary" (click)="RestoreFolder(data.item)" cdkFocusInitial>Restore</button>
    </div>  -->
    <!-- <div class="dds__modal-footer"  *ngIf="!data.activeFilesCount">
     <p>No Files/Articles created to restore the folder.</p>
     <button class="dds__btn dds__btn-secondary" (click)="onNoClick()">Close</button>
    </div>  -->
  </div>
 
</div>

<!-- New Pop up design-->

<!-- <div *ngIf="data.mode==='restore' && data.item.type=='Folder'" id="exampleModal" tabindex="-1" class="dds__modal dds__fade" role="dialog" aria-labelledby="dds__modal-title1" aria-hidden="true" style=""> 
  <div class="dds__modal-dialog" role="document"> <div class="dds__modal-content"> 
    <div class="dds__modal-header"> <h3 class="dds__modal-title" id="dds__modal-title1">Sample Title</h3> </div> <button class="dds__close" data-dismiss="dds__modal" aria-label="Close"> <span class="dds__icons dds__close-x" aria-hidden="true"></span> </button> <div class="dds__modal-body"> <p>Modal body text goes here.</p> </div> <div class="dds__modal-footer"> <button class="dds__btn dds__btn-secondary" data-dismiss="dds__modal">Close</button> <button class="dds__btn dds__btn-primary">Save changes</button> </div> </div> </div></div> -->